import { Component, EventEmitter, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ecg-delete-invoice-file-modal',
  templateUrl: './delete-invoice-file-modal.component.html',
  styleUrls: ['./delete-invoice-file-modal.component.scss']
})
export class DeleteInvoiceFileModalComponent {

  deleteEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(public modal: NgbModal, public activeModal: NgbActiveModal) { }

  confirm() {
    this.deleteEvent.emit();
    this.activeModal.close();
  }
}
